module.exports = __webpack_public_path__ + "static/media/spicyrealcrabmeat.fc45cb19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/spicyrealcrabmeat.jpg
// module id = 111
// module chunks = 0